import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonText } from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PuzzleWinDialogInjectableInterface } from '../../shared-module/puzzle-win-dialog/puzzle-win-dialog-injectable.interface';
import { Store } from '@ngxs/store';
import { PuzzleGameState } from '../../store/puzzle-game.state';
import { PuzzleTimeRecordState } from '../../store/puzzle-time-record.state';
import { PuzzleGameModel } from '../../store/puzzle-game.model';
import { PuzzleTimeRecordModel } from '../../store/puzzle-time-record.model';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { PuzzleFrameworkService } from '../../puzzle-framework-module/puzzle-framework.service';
import { PuzzleWinDialogService } from '../../shared-module/puzzle-win-dialog/puzzle-win-dialog.service';

@Component({
  selector: 'lib-app-hashi-win-screen',
  templateUrl: './hashi-win-screen.component.html',
  styleUrls: ['./hashi-win-screen.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, IonText],
})
export class HashiWinScreenComponent implements PuzzleWinDialogInjectableInterface, OnDestroy {
  public data: any;

  public moveCounter: number;
  public duration: string;
  public translationKey: string;

  private puzzleGameSubscription: Subscription;
  private timeRecordSubscription: Subscription;

  constructor(
    private store: Store,
    private framework: PuzzleFrameworkService,
    private winDialogService: PuzzleWinDialogService,
    private translateService: TranslateService
  ) {
    this.store
      .select((state) => state.puzzleID)
      .subscribe((puzzleID) => {
        this.puzzleGameSubscription = this.store
          .select(PuzzleGameState.getByID(puzzleID))
          .subscribe((puzzleGame: PuzzleGameModel) => {
            if (puzzleGame) {
              this.moveCounter = puzzleGame.moveCounter;
            }
          });
        this.timeRecordSubscription = this.store
          .select(PuzzleTimeRecordState.getTimeRecordByID)
          .pipe(map((filterFn) => filterFn(puzzleID)))
          .subscribe((timeRecord: PuzzleTimeRecordModel) => {
            if (timeRecord) {
              this.duration = timeRecord.timeRecord.timeString;
            }
          });
      });

    this.translationKey = this.framework.getTranslationKey();

    this.translateService
      .get(this.translationKey + '.win_dialog.title')
      .toPromise()
      .then((title) => {
        if (title) {
          this.winDialogService.setTitle(title);
        }
      });
  }

  ngOnDestroy(): void {
    if (this.puzzleGameSubscription) {
      this.puzzleGameSubscription.unsubscribe();
    }
    if (this.timeRecordSubscription) {
      this.timeRecordSubscription.unsubscribe();
    }
  }

  setData(data: any): void {
    this.data = data;
  }
}
